import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import CustomDialog from '../dialogs/CustomDialog';
import EventReminderForm from './EventReminderForm';
import EventReminderResult from './EventReminderResult';

const  EventReminder = (props) => {

  const [formVisible, setFormVisible] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(true);

  const openDialog = () => {
    setDialogOpen(true);
    setFormVisible(true);
  };

  const closeDialog = () => {
    setDialogOpen(false);
  };

  const showForm = () => {
    setFormVisible(true);
  };

  const {
    onRequestReminder,
    showReminderResult,
    reminderResultSuccessful,
    showNewsletterResult,
    newsletterResultStatus,
  } = props;

  return (
    <div className="col-xs-16 col-sm-6 event-reminder-container">
      {!showReminderResult && (
        <div className="notification-container">
          {eventReminderBody}
          <button className="primary" onClick={openDialog}>
            <FormattedMessageWrappedInSpan
              id="eventReminder.action.accept"
              defaultMessage="Notify me"
            />
          </button>
        </div>
      )}
      <CustomDialog open={dialogOpen} onRequestClose={closeDialog}>
        {!showReminderResult &&
          formVisible && (
            <EventReminderForm onRequestReminder={onRequestReminder} />
          )}
        {!formVisible && (
          <div className="notification-container">
            <DialogContent>
              {eventReminderBody}
            </DialogContent>
            <DialogActions>
              <div className="notification-action">
                <button onClick={closeDialog}>
                  <FormattedMessageWrappedInSpan
                    id="eventReminder.cancelButton"
                    defaultMessage="Cancel"
                  />
                </button>
                <button className="accept" onClick={showForm}>
                  <FormattedMessageWrappedInSpan
                    id="eventReminder.acceptButton"
                    defaultMessage="Notify me"
                  />
                </button>
              </div>
            </DialogActions>
          </div>
        )}
        <EventReminderResult
          showReminderResult={showReminderResult}
          reminderResultSuccessful={reminderResultSuccessful}
          showNewsletterResult={showNewsletterResult}
          newsletterResultStatus={newsletterResultStatus}
          closeDialog={closeDialog}
        />
      </CustomDialog>
    </div>
  );
}

const eventReminderBody = (
  <div className="notification-body">
    <div className="event-reminder-icon" />
    <h1>
      <FormattedMessageWrappedInSpan
        id="eventReminder.title"
        defaultMessage="We are on it!"
      />
    </h1>
    <FormattedMessageWrappedInSpan
      id="eventReminder.noPhotosText"
      defaultMessage="The photos are not online yet."
      description="The text that tells the user that the fotos are not online yet."
    />
    <FormattedMessageWrappedInSpan
      id="eventReminder.requestReminderText"
      defaultMessage="Get a notification as soon as your pictures are online."
      description="The text that tells the user that he can get a reminder"
    />
  </div>
);

EventReminder.propTypes = {
  onRequestReminder: PropTypes.func,
  showReminderResult: PropTypes.bool,
  reminderResultSuccessful: PropTypes.bool,
  showNewsletterResult: PropTypes.bool,
  newsletterResultStatus: PropTypes.string,
};

export default EventReminder;
